import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const useSortOptions = () => {
  const { t } = useTranslation();

  const sortOptions: { value: string; label: string }[] = useMemo(
    () => [
      {
        value: 'default',
        label: t('sort.recommended', 'Recommended'),
      },
      {
        value: 'priceLowHigh',
        label: t('sort.priceLowHigh', 'Price: Low–High'),
      },
      {
        value: 'priceHighLow',
        label: t('sort.priceHighLow', 'Price: High–Low'),
      },
      {
        value: 'dataLowHigh',
        label: t('sort.dataLowHigh', 'Data: Low–High'),
      },
      {
        value: 'dataHighLow',
        label: t('sort.dataHighLow', 'Data: High–Low'),
      },
    ],
    [t],
  );

  return sortOptions;
};
